import React, { useEffect, useState } from 'react';
import { Box } from 'glints-aries';
import Markdown from 'react-markdown';
import { useSelector } from 'react-redux';

import { CountryCodes } from 'src/common/enums';
import { useConfig } from 'src/common/hooks';
import { ROUTES } from 'src/common/routes';
import GlintsContainer from 'src/components/GlintsContainer';
import { MetadataRenderer } from 'src/components/MetaDescription/MetadataRenderer';
import { getCountryWithSGFallback } from 'src/modules/ClientConfig/Selectors';

import { PrivacyPolicy } from './PrivacyPolicy';
import { TermsOfUse } from './TermsOfUse';
import * as S from './TermsPage.sc';

export const TermsPage = () => {
  const [markdownTerms, setMarkdownTerms] = useState();
  const { LANG } = useConfig();
  const COUNTRY = useSelector(getCountryWithSGFallback);

  useEffect(() => {
    if (COUNTRY === CountryCodes.TW) {
      window.location.replace(`/sg/${ROUTES.terms}`);
      return;
    }
    import(`./terms/${COUNTRY}/${LANG.toLowerCase()}.md`)
      .then((module) => {
        setMarkdownTerms(module.default);
      })
      .catch(() => {
        console.error(
          `User agreement not found for ${COUNTRY} for language ${LANG.toLowerCase()}`
        );
      });
  }, [LANG, COUNTRY]);

  if (markdownTerms) {
    return (
      <S.TermsPageContainer>
        <Box pt={24}>
          <MetadataRenderer title="User Agreement" />
          <S.MarkdownGlintsContainer>
            <Markdown>{markdownTerms}</Markdown>
          </S.MarkdownGlintsContainer>
        </Box>
      </S.TermsPageContainer>
    );
  }

  return (
    <S.TermsPageContainer>
      <Box pt={24}>
        <MetadataRenderer
          title="Terms of Use & Privacy Policy"
          glintsTrackingName="terms"
        />
        <GlintsContainer>
          <TermsOfUse />
          <PrivacyPolicy />
        </GlintsContainer>
      </Box>
    </S.TermsPageContainer>
  );
};
